import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';

export const getFlexibleDatesUSPMarkup = (params: GetFeaturesInnerParams, text?: string) => {
  const { isMobile, t, showFlexibleAlternativeDates, isOverlay } = params;
  const mobileUsp = t('vacation.oss.alternative_dates.usp_mobile');
  const desktopUsp = t('vacation.oss.alternative_dates.usp');

  if (showFlexibleAlternativeDates && !isOverlay) {
    return `${text} <span class="more">${isMobile ? mobileUsp : desktopUsp}</span>`;
  }

  return text;
};

export const getDatesWithoutMealLabel = (params: GetFeaturesInnerParams): string | undefined => {
  const { nightsText, datesText, isHO, isFlexible } = params;

  if (isHO && isFlexible) return `${nightsText} · ${datesText}`;
  if (isHO) return undefined;
  return nightsText;
};

export const getDatesWithMealLabel = (params: GetFeaturesInnerParams) => {
  const { meal, nightsCount, nightsText, t } = params;
  if (meal) {
    return nightsCount === 1
      ? t('vacation.oss.cards.stay_night_meal', { mealplan: `<b>${meal}</b>` })
      : t('vacation.oss.cards.stay_nights_meal', { amount: `${nightsCount}`, mealplan: `<b>${meal}</b>` });
  }

  return nightsText;
};
